import { Limit, LimiteGeralModel, LimiteTipoPeriodo, LimiteViewModel, PeriodoLimiteModel } from './models/limits';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LimitsService } from './limits.service';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Util } from '../../utils/util';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../../shared/EventTypes';
import { TransfersDataViewModel } from './models/select-ajust-limits';

@Component({
	selector: 'app-limits',
	templateUrl: './limits.component.html',
	styleUrls: ['./limits.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class LimitsComponent implements OnInit {

	public pixTransfersViewModel: LimiteViewModel = new LimiteViewModel('Transferência Pix');
	public pixWithdrawChangeTransfersViewModel: LimiteViewModel = new LimiteViewModel('Pix saque e troco');
	public tedTransfersViewModel: LimiteViewModel = new LimiteViewModel('Transferência TED');
	public nextViewData: TransfersDataViewModel = new TransfersDataViewModel();
	public tedPeriodLimit: Limit;

	constructor(private limitsService: LimitsService, public dialog: MatDialog, private router: Router) { }

	ngOnInit() {
		this.getTedLimitPeriod();
	}

	getTedLimitPeriod() {
		this.limitsService.getDataLimits().subscribe(data => {
			const listLimits = data[0];
			this.tedPeriodLimit = listLimits.find(e => e.typeLimit === 'TED');

			this.getLimits();
		}, error => {
			this.handleError(error);
			this.router.navigate(['/minha-conta/meu-pacote']);
		});
	}

	getLimits(): void {
		this.limitsService.getLimitsV2().subscribe(data => {
			if (data.Sucesso) {
				const result = Util.keysToCamel(data.Retorno) as Array<LimiteGeralModel>;

				result.forEach((item) => {
					switch (item.Tipo) {
						case LimiteTipoPeriodo.PIX_DIURNO:
							this.setLimitModel('diurno', this.pixTransfersViewModel, item);
							break;
						case LimiteTipoPeriodo.PIX_NOTURNO:
							this.setLimitModel('noturno', this.pixTransfersViewModel, item);
							break;
						case LimiteTipoPeriodo.QRCODE_PIX_SAQUE_TROCO_DIURNO:
							this.setLimitModel('diurno', this.pixWithdrawChangeTransfersViewModel, item);
							break;
						case LimiteTipoPeriodo.QRCODE_PIX_SAQUE_TROCO_NOTURNO:
							this.setLimitModel('noturno', this.pixWithdrawChangeTransfersViewModel, item);
							break;
						case LimiteTipoPeriodo.TED_DIURNO:
							this.setLimitModel('diurno', this.tedTransfersViewModel, item);
							this.tedTransfersViewModel.limiteDiurno.horarioInicial = this.showSeparatedTime(this.tedPeriodLimit.timeLimit, true);
							this.tedTransfersViewModel.limiteDiurno.horarioFinal = this.showSeparatedTime(this.tedPeriodLimit.timeLimit, false);
							break;
						default:
							break;
					}
				});
			}
		}, (error: any) => {
			this.handleError(error);
			this.router.navigate(['/minha-conta/meu-pacote']);
		});
	}

	inAnalysisLimit(desiredLimitValue: number): boolean {
		return !!desiredLimitValue && desiredLimitValue > 0;
	}

	getValueLimit(limit: PeriodoLimiteModel): number {
		return limit.valorLimiteRequisitado ? limit.valorLimiteRequisitado : limit.valor;
	}

	setLimitModel(period: string, model: LimiteViewModel, data: LimiteGeralModel): void {
		if (period === 'diurno') {
			model.limiteDiurno.tipo = data.Tipo;
			model.limiteDiurno.valor = data.Valor;
			model.limiteDiurno.valorMaximo = data.ValorMaximo;
			model.limiteDiurno.horarioInicial = `${this.formatTime(data.FaixaHorario.HorarioInicial)}`;
			model.limiteDiurno.horarioFinal = `${this.formatTime(data.FaixaHorario.HorarioFinal)}`;
			model.limiteDiurno.valorLimiteRequisitado = data.ValorLimiteRequisitado;
		} else {
			model.limiteNoturno.tipo = data.Tipo;
			model.limiteNoturno.valor = data.Valor;
			model.limiteNoturno.valorMaximo = data.ValorMaximo;
			model.limiteNoturno.horarioInicial = `${this.formatTime(data.FaixaHorario.HorarioInicial)}`;
			model.limiteNoturno.horarioFinal = `${this.formatTime(data.FaixaHorario.HorarioFinal)}`;
			model.limiteNoturno.valorLimiteRequisitado = data.ValorLimiteRequisitado;
		}
	}

	showSeparatedTime(time: string, isStart: boolean) {
		const startTime = this.formatTime((time).slice(0, 5));
		const endTime = this.formatTime((time).slice(9, 14));

		if (isStart) {
			return `${startTime}`;
		}

		return `${endTime}`;
	}

	formatTime(time: string): string {
		const hours = parseInt((time).slice(0, 2), 10);
		const minutes = parseInt((time).slice(3, 5), 10);

		const minutesFormatted = minutes < 10 ? '0' + minutes.toString() : minutes.toString();

		if (minutes === 0) {
			return `${hours}h`;
		}

		return `${hours}:${minutesFormatted}h`;
	}

	public seeOtherLimits(): void {
		this.router.url === '/minha-conta/meus-limites' ? this.router.navigate(['/minha-conta/meus-limites/outros-limites']) : this.router.navigate(['/pix/limites/outros-limites']);
	}

	public seeFaq(): void {
		this.router.url === '/minha-conta/meus-limites' ? this.router.navigate(['/minha-conta/meus-limites/duvidas']) : this.router.navigate(['/pix/limites/duvidas']);
	}

	public changeLimits(selectedLimit: LimiteViewModel): void {
		this.setNextViewData(selectedLimit);

		this.router.url === '/minha-conta/meus-limites' ? this.router.navigate(['/minha-conta/meus-limites/selecionar-limite']) : this.router.navigate(['/pix/limites/selecionar-limite']);
	}

	setNextViewData(selectedLimit: LimiteViewModel): void {
		switch (selectedLimit.nome) {
			case 'Transferência Pix':
				this.nextViewData.type = 'pix';
				this.nextViewData.title = 'Limites para transferências Pix';
				this.nextViewData.description = 'Selecione o limite que deseja ajustar, o aumento de limite leva no mínimo 24h.';
				break;
			case 'Pix saque e troco':
				this.nextViewData.type = 'pix-withdraw-change';
				this.nextViewData.title = 'Limites Pix saque e Pix troco';
				this.nextViewData.description = 'Selecione o limite que deseja ajustar, o aumento de limite leva no mínimo 24h.';
				break;
			case 'Transferência TED':
				this.nextViewData.type = 'ted';
				this.nextViewData.title = 'Limite TED';
				this.nextViewData.description = 'Confira e/ou ajuste o limite abaixo, o aumento de limite leva no mínimo 24h.';
				break;
			default:
				break;
		}

		this.nextViewData.limitViewModel = selectedLimit;
		this.saveTransferModelData(this.nextViewData);
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });

	showPixDayTransfers = (): boolean => (this.pixTransfersViewModel && !!this.pixTransfersViewModel.limiteDiurno.valor && !!this.pixTransfersViewModel.limiteDiurno.horarioInicial && !!this.pixTransfersViewModel.limiteDiurno.horarioFinal);

	showPixNightTransfers = (): boolean => (this.pixTransfersViewModel && !!this.pixTransfersViewModel.limiteNoturno.valor && !!this.pixTransfersViewModel.limiteNoturno.horarioInicial && !!this.pixTransfersViewModel.limiteNoturno.horarioFinal);

	showPixDayWithdrawChangeTransfers = (): boolean => (this.pixWithdrawChangeTransfersViewModel && !!this.pixWithdrawChangeTransfersViewModel.limiteDiurno.valor && !!this.pixWithdrawChangeTransfersViewModel.limiteDiurno.horarioInicial && !!this.pixWithdrawChangeTransfersViewModel.limiteDiurno.horarioFinal);

	showPixNightWithdrawChangeTransfers = (): boolean => (this.pixWithdrawChangeTransfersViewModel && !!this.pixWithdrawChangeTransfersViewModel.limiteNoturno.valor && !!this.pixWithdrawChangeTransfersViewModel.limiteNoturno.horarioInicial && !!this.pixWithdrawChangeTransfersViewModel.limiteNoturno.horarioFinal);

	showTedTransfers = (): boolean => (this.tedTransfersViewModel && !!this.tedTransfersViewModel.limiteDiurno.valor && !!this.tedTransfersViewModel.limiteDiurno.horarioInicial && !!this.tedTransfersViewModel.limiteDiurno.horarioFinal);

	saveTransferModelData(data: TransfersDataViewModel): void {
		sessionStorage.removeItem('limitTransferData');
		sessionStorage.setItem('limitTransferData', JSON.stringify(data));
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limits/limits.component.ts